export default {
    path: '/complaint',
    meta: {
        title: '投诉建议',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/complaint`),
}


// WEBPACK FOOTER //
// ./src/views/Complaint/router.js